import { TradingBlockAchBankLinkStatusEnum } from '../dtos/achBankLinks.dtos';

export namespace AchBankLinkConstant {
  export const PENDING_STATUS_LIST = [
    TradingBlockAchBankLinkStatusEnum.PendingCreateApproval,
    TradingBlockAchBankLinkStatusEnum.PendingCreateApproval,
  ];
}
